import T6v2 from "../../components/ExcerciseTypes/TypeIn/T6v2";
import Circle_Write from "../../components/ExcerciseTypes/Circle_Write";
import T6 from "../../components/ExcerciseTypes/TypeIn/T6";

const json = {
  1: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P4-E1",
    audio: "Audios/bt_fpt_ai/p24_intro.mp3",
    autoPlay: true,
    video: "",
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page24/Key/E1answerKey.png",
    component: T6,
    isHiddenCheck: true,
    // hideBtnFooter:true,
    maxLength: 5,
    stylesTextInput: {
      borderBottom: "3px dotted black",
      maxLength: 4,
      textAlign: "center",
      background: "none",
      fontSize: 24,
    },
    inputSize: 80,
    titleQuestion: [
      {
        num: "1",
        title: `
			  Quan sát thước đo góc rồi nháy chuột vào chỗ chấm để viết số đo của mỗi góc.
		    `,
        color: "rgb(99,197,244)",
      },
    ],
    // newWords: [
    //   {
    //     title: "Tra cứu",
    //     description: `
    //     <span>Đang cập nhật</span>
        
    //     `,
    //   },
    // ],
    guideModal: [
      {
        title: "hướng dẫn",
        description: `
        Quan sát hình rồi nháy chuột vào chỗ chấm để điền câu trả lời.
        <video src="Audios/bt_fpt_ai/guide/p24_e1.mp3" controls style="width: 100%; height: 2cm"></video>
        `,
      },
    ],
    questionImage: [],
    // hideBtnFooter: true,
    questions: [
      {
        title: `
        <div style='position: relative'>
        <img src='/img/FriendsPlus/Page24/E1/1.jpg' style='height:18cm; width: 27cm; margin-bottom: 30px'/>
        <div style='position: absolute; top: 280px; left: 39px; display: flex'>
        <span style='padding-right: 80px'>Góc đỉnh O; cạnh OA, OB bằng <input id= "0"><sup>o</sup></span>
        <span style=''>Góc đỉnh O; cạnh OC, OD bằng <input id= "0"><sup>o</sup></span>
        </div>
        <div style='position: absolute; top: 668px; left: 39px; display: flex'>
        <span style='padding-right: 80px'>Góc đỉnh O; cạnh OE, OG bằng <input id= "2"><sup>o</sup></span>
        <span style=''>Góc đỉnh O; cạnh OM, ON bằng <input id= "3"><sup>o</sup></span>
        </div>
        </div>
        `,
        answer: ["70", "90", "120", "180"],
      },
    ],
  },
};

export default json;
